module.exports = __webpack_public_path__ + "static/media/retail-img.0a81e240.png";